'use strict'

var forms = forms || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
forms.init = function () {
  forms.start()

  // Fix behaviors.
  Drupal.behaviors.start = {
    attach: function (context, settings) {
      forms.start()
    },
  }
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(forms.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
forms.start = function () {

  // console.info('forms');

  $('form .form-group:not(.form-type-checkbox):first-child').addClass('filled')
  $('form .form-group:not(.form-type-checkbox):first-child input').focus()

  $('form input:not(.form-type-checkbox)').on('blur input focus', function () {
    var $field = $(this).closest('.form-group')
    if (this.value) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  })

  $('form input:not(.form-type-checkbox)').on('focus', function () {
    var $field = $(this).closest('.form-group')
    if (this) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  })

  $('form textarea').on('blur input focus', function () {
    var $field = $(this).closest('.form-group')
    if (this.value) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  })

  $('form textarea').on('focus', function () {
    var $field = $(this).closest('.form-group')
    if (this) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  })

  $('form input:not(.form-type-checkbox)').each(function() {
    var $field = $(this).closest('.form-group')
    if ($(this).val()) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  });

  $('form textarea ').each(function() {
    var $field = $(this).closest('.form-group')
    if ($(this).val()) {
      $field.addClass('filled')
    }
    else {
      $field.removeClass('filled')
    }
  });

}
